<template>
    <div class="sansOnglet" v-loading.fullscreen="loading"
         :element-loading-text="texteLoading">
        <el-row>
            <el-col :lg="6" :xl="6" :sm="24" :md="24" :xs="24">
                <div class="text-left titrePartieSansOngletsCreation" style="margin-left: 10px">NOUVEAU FLUX A CREER
                </div>
                <div class="texteInfoOnglet text-justify" style="margin-left: 10px">Tous les champs sont à compléter
                    pour que notre équipe technique puisse paramétrer votre flux diffuseur.
                </div>
            </el-col>
            <el-col :lg="18" :xl="18" :sm="24" :md="24" :xs="24">
                <div class="pageSansOngletsNouveauFlux" v-if="this.$store.getters.getUserDiffuseurAgence() == null
                                                                || this.$store.getters.getUserDiffuseurCmi() == null
                                                                || this.$store.getters.getUserDiffuseurPromoteur() == null
                                                                || this.$store.getters.getUserDiffuseurAuto() == null
                                                                || this.$store.getters.getUserDiffuseurMoto() == null">
                    <el-form label-position="right" ref="nouveauDiffuseur"
                             :model="nouveauDiffuseur"
                             :rules="rules"
                             :hide-required-asterisk="true"


                    >
                        <el-row>
                            <el-col :sm="24" :xs="24" class="text-left">
                                <el-form-item label="Nom du diffuseur">
                                    <el-input v-model="nouveauDiffuseur.nomDiffuseur"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :xs="24" class="text-left">
                                <el-form-item label="URL">
                                    <el-input v-model="nouveauDiffuseur.url"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :xs="24" class="text-left">
                                <el-form-item label="Univers *" prop="univers">
                                    <el-radio-group v-model="nouveauDiffuseur.univers"
                                                    :disabled="clientCommunValide"
                                                    @change="gestionAffichageCodeClient">
                                        <el-radio label="Immobilier" name="typeUnivers" v-if="this.$store.getters.getUserDiffuseurPromoteur() == null
                                                                                                   || this.$store.getters.getUserDiffuseurAgence() == null
                                                                                                   || this.$store.getters.getUserDiffuseurCmi() == null"></el-radio>
                                        <el-radio label="Automobile" name="typeUnivers" v-if="this.$store.getters.getUserDiffuseurAuto() == null
                                                                                                   || this.$store.getters.getUserDiffuseurMoto() == null"></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <!--SI IMMO-->
                            <el-col :sm="24" :xs="24" class="text-left"
                                    v-if="nouveauDiffuseur.univers == 'Immobilier'">
                                <el-form-item label="Métier concerné *" prop="metierImmo"><br/>
                                    <el-col :sm="24" :xs="24" class="text-left">
                                        <el-radio-group v-model="nouveauDiffuseur.metierImmo"
                                                        :disabled="clientCommunValide"
                                                        @change="gestionAffichageCodeClient">
                                            <el-radio label="Offre (vente/location)" name="metierImmo"
                                                      class="checkTypeDeBien"
                                                      v-if="this.$store.getters.getUserDiffuseurAgence() == null"></el-radio>
                                            <el-radio label="Bien particulier/professionnels" name="metierImmo"
                                                      class="checkTypeDeBien"
                                                      v-if="this.$store.getters.getUserDiffuseurAgence() == null"></el-radio>
                                            <el-radio label="Maison individuelles (Constructeurs)" name="metierImmo"
                                                      class="checkTypeDeBien"
                                                      v-if="this.$store.getters.getUserDiffuseurCmi() == null"></el-radio>
                                            <el-radio label="Programmes (totalité programme neuf)" name="metierImmo"
                                                      class="checkTypeDeBien"
                                                      v-if="this.$store.getters.getUserDiffuseurPromoteur() == null"></el-radio>
                                            <el-radio label="Programmes (annonce par bien)" name="metierImmo"
                                                      class="checkTypeDeBien"
                                                      v-if="this.$store.getters.getUserDiffuseurPromoteur() == null"></el-radio>
                                        </el-radio-group>
                                    </el-col>
                                </el-form-item>
                            </el-col>
                            <!--SI vo-->
                            <el-col :sm="24" :xs="24" class="text-left"
                                    v-if="nouveauDiffuseur.univers == 'Automobile'"><br/>
                                <el-form-item label="Métier concerné *" prop="metierVo">
                                    <el-radio-group v-model="nouveauDiffuseur.metierVo"
                                                    :disabled="clientCommunValide"
                                                    @change="gestionAffichageCodeClient">
                                        <el-radio label="Voitures et utilitaires" name="metierVo"
                                                  v-if="this.$store.getters.getUserDiffuseurAuto() == null"></el-radio>
                                        <el-radio label="Motos" name="metierVo"
                                                  v-if="this.$store.getters.getUserDiffuseurMoto() == null"></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :xs="24" class="text-left">
                                <el-form-item label="Modèle économique *" prop="modeleEconomique"
                                              v-if="nouveauDiffuseur.univers !=''">
                                    <el-radio-group v-model="nouveauDiffuseur.modeleEconomique"
                                                    :disabled="clientCommunValide"
                                                    @change="gestionAffichageCodeClient">
                                        <el-radio label="Gratuit">Gratuit
                                        </el-radio>
                                        <el-radio label="Freemium">Freemium
                                        </el-radio>
                                        <el-radio label="Payant">Payant
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :xs="24" class="text-left"
                                    v-if="nouveauDiffuseur.modeleEconomique == 'Gratuit'">
                                <el-form-item label="Limite nombre d'annonces gratuites ? *"
                                              prop="nbAnnoncesGratuites"
                                >
                                    <el-input-number v-model="nouveauDiffuseur.nbAnnoncesGratuites"
                                                     controls-position="right" :disabled="clientCommunValide"
                                                     :min="0"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :xs="24" class="text-left" v-if="nouveauDiffuseur.modeleEconomique != ''
                                                                               && ((nouveauDiffuseur.univers == 'Immobilier' && nouveauDiffuseur.metierImmo)
                                                                               || (nouveauDiffuseur.univers == 'Automobile' && nouveauDiffuseur.metierVo))">
                                <el-form-item label="Identification annonceur commun *" prop="clientCommun">
                                        <span><el-popover
                                                placement="top-start"
                                                trigger="hover">
                                             <div class="textPopover">
                                                <h4 class="titrePopover">Identification annonceur commun</h4>
                                                <div>L’identification d’un client commun est obligatoire pour la <br/>mise en place d’une affiliation.
                                                Attention à ne pas confondre <br/>client et utilisateur. Un client commun est un annonceur qui<br/>
                                                souhaite diffuser sur votre plateforme et qui souscrit aux <br/>offres Ubiflow. Merci de recueillir
                                                le code AG suivi de 6 <br/>chiffres auprès du client commun.
                                                </div>
                                            </div>
                                                <el-button slot="reference" class="informationsComplementaires"
                                                           icon="el-icon-question"
                                                           type="text" circle></el-button>
                                        </el-popover></span>
                                    <el-input v-model="nouveauDiffuseur.clientCommun"
                                              v-mask="'############'"
                                              :disabled="clientCommunValide"
                                              class="ClientCommunInput"
                                    >
                                        <template slot="prepend">ag</template>
                                        <el-button v-if="!nouveauDiffuseur.validationCodeClient" slot="append"
                                                   style="border: none;background-color: #21b1be;color: white"
                                                   v-on:click="validationCodeClient">Valider
                                        </el-button>
                                        <el-button v-else style="border: none;background-color: #21b1be;color: white"
                                                   slot="append" v-on:click="effacerCodeClientCommun">Modifier
                                        </el-button>
                                    </el-input>
                                </el-form-item>
                                <br/>
                            </el-col>
                            <el-col :sm="24" :xs="24" class="text-center"
                                    v-if="nouveauDiffuseur.validationCodeClient">
                                <div style="color: #3bb299; font-size: medium;margin-bottom: 30px;">
                                    <small>
                                        Le code client correspond au compte : {{ nouveauDiffuseur.nomDuClientCommun
                                        }}
                                    </small>
                                </div>
                            </el-col>
                            <el-col :sm="24" :xs="24" class="text-center"
                                    v-if="erreurClientCommun">
                                <div style="color: red;  font-size: medium;margin-bottom: 30px;">
                                    <small>
                                        Le code client renseigné n'est pas valide ou le client existe mais n'a pas
                                        la typologie
                                        compatible.<br/>Vous devez renseigner un code client valide pour poursuivre
                                        le
                                        questionnaire.
                                    </small>
                                </div>
                            </el-col>
                        </el-row>
                        <div v-if="nouveauDiffuseur.validationCodeClient">
                            <el-row>
                                <el-col :sm="24" :xs="24" class="text-left"
                                        v-if="nouveauDiffuseur.modeleEconomique == 'Gratuit'">
                                    <el-form-item label="Bouquet visibilité *" prop="bouquetVisibilite">
                                         <span><el-popover
                                                 placement="top-start"
                                                 trigger="hover"
                                         >
                                            <div class="textPopover">
                                                <h4 class="titrePopover">Bouquet visibilité</h4>
                                                <div>En tant que portail gratuit, nous vous proposons de vous <br/>faire apparaitre dans notre bouquet visibilité.
                                                    Les clients <br/>Ubiflow ont la possibilité depuis leur espace client de <br/>diffuser automatiquement vers tous
                                                    les portails du bouquet <br/>visibilité.
                                                </div>
                                            </div>
                                                <el-button slot="reference" class="informationsComplementaires"
                                                           icon="el-icon-question"
                                                           type="text" circle></el-button>
                                        </el-popover></span>
                                        <el-radio-group v-model="nouveauDiffuseur.bouquetVisibilite">
                                            <el-radio label="Oui"></el-radio>
                                            <el-radio label="Non"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>

                                <!--Catégories IMMO-->
                                <el-col :sm="24" :xs="24" class="text-left"
                                        v-if="nouveauDiffuseur.univers == 'Immobilier'">
                                    <div v-if="nouveauDiffuseur.modeleEconomique == 'Payant' || nouveauDiffuseur.bouquetVisibilite == 'Non'">
                                        <el-form-item label="Catégories *" prop="categoriesImmo">
                                            <small class="messageCategories">3 choix possibles maximum</small>

                                            <el-checkbox-group v-model="nouveauDiffuseur.categoriesImmo" :min="0"
                                                               :max="3" @change="gestionCategories">
                                                <el-col :sm="24" :xs="24" class="text-left">
                                                    <el-checkbox label="site client privé" name="categoriesImmo"
                                                                 :disabled="desactiverCategorieSiteClient">Site client
                                                        privé
                                                    </el-checkbox>
                                                    <el-checkbox label="généralistes"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Généralistes
                                                    </el-checkbox>
                                                    <el-checkbox label="nationaux" name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Nationaux
                                                    </el-checkbox>
                                                    <el-checkbox label="régionaux" name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Régionaux
                                                    </el-checkbox>
                                                    <el-checkbox label="journaux régionaux"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Journaux régionaux
                                                    </el-checkbox>
                                                    <el-checkbox label="internationaux"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Internationaux
                                                    </el-checkbox>
                                                    <el-checkbox label="programmes neufs"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Programmes neufs
                                                    </el-checkbox>
                                                    <el-checkbox label="commerces" name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Commerces
                                                    </el-checkbox>
                                                    <el-checkbox label="luxe" name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Luxe
                                                    </el-checkbox>
                                                    <el-checkbox label="location" name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Location
                                                    </el-checkbox>
                                                    <el-checkbox label="spécialisés : fédérations professionnelles"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Fédérations professionnelles
                                                    </el-checkbox>
                                                    <el-checkbox label="spécialisés : spécifiques réseaux"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Spécifiques réseaux
                                                    </el-checkbox>
                                                    <el-checkbox label="terrains / opérations terrain+maison"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Terrain + maison
                                                    </el-checkbox>
                                                    <el-checkbox label="vitrines informatisées"
                                                                 name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Vitrines informatisées
                                                    </el-checkbox>
                                                    <el-checkbox label="spécialisés : autres" name="categoriesImmo"
                                                                 :disabled="desactiverCategoriesImmo"
                                                    >Autres
                                                    </el-checkbox>
                                                </el-col>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <!--Catégorie VO-->
                                <el-col :sm="24" :xs="24" class="text-left"
                                        v-if="nouveauDiffuseur.univers == 'Automobile'">
                                    <div v-if="nouveauDiffuseur.modeleEconomique == 'Payant' || nouveauDiffuseur.bouquetVisibilite == 'Non'">
                                        <el-form-item label="Catégories *" prop="categoriesVo">
                                            <small class="messageCategories">3 choix possibles maximum</small>
                                            <el-checkbox-group v-model="nouveauDiffuseur.categoriesVo" :min="0"
                                                               :max="3" @change="gestionCategories">
                                                <el-col :sm="24" :xs="24" class="text-left">
                                                    <el-checkbox label="site client privé" name="categoriesVo"
                                                                 :disabled="desactiverCategorieSiteClient">Site client
                                                        privé
                                                    </el-checkbox>
                                                    <el-checkbox label="généralistes"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Généralistes
                                                    </el-checkbox>
                                                    <el-checkbox label="nationaux" name="categoriesVo"
                                                                 :disabled="desactiverCategoriesVo"
                                                    >Nationaux
                                                    </el-checkbox>
                                                    <el-checkbox label="régionaux" name="categoriesVo"
                                                                 :disabled="desactiverCategoriesVo"
                                                    >Régionaux
                                                    </el-checkbox>
                                                    <el-checkbox label="journaux régionaux"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Journaux régionaux
                                                    </el-checkbox>
                                                    <el-checkbox label="internationaux"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Internationaux
                                                    </el-checkbox>
                                                    <el-checkbox label="spécialisés : fédérations professionnelles"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Fédérations professionnelles
                                                    </el-checkbox>
                                                    <el-checkbox label="spécialisés : spécifiques réseaux"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Spécifiques réseaux
                                                    </el-checkbox>
                                                    <el-checkbox label="vitrines informatisées"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Vitrines informatisées
                                                    </el-checkbox>
                                                    <el-checkbox label="véhicules neufs"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Véhicules neufs
                                                    </el-checkbox>
                                                    <el-checkbox label="2 roues"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Deux roues
                                                    </el-checkbox>
                                                    <el-checkbox label="constructeurs"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Constructeurs
                                                    </el-checkbox>
                                                    <el-checkbox label="utilitaires / camions"
                                                                 name="categoriesVo" :disabled="desactiverCategoriesVo"
                                                    >Utilitaires / camions
                                                    </el-checkbox>
                                                    <el-checkbox label="spécialisés : autres" name="categoriesVo"
                                                                 :disabled="desactiverCategoriesVo"
                                                    >Autres
                                                    </el-checkbox>
                                                </el-col>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :sm="24" :xs="24" class="text-left" v-if="afficherChoixVisibilite">
                                    <el-form-item
                                            label="Etre visible auprès des annonceurs dans l’espace client Ubiflow  *"
                                            prop="prive">
                                        <el-radio-group v-model="nouveauDiffuseur.prive">
                                            <el-radio label='Non'>Oui</el-radio>
                                            <el-radio label='Oui'>Non</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!--DEBUT LOGO-->
                            <el-row>
                                <el-form-item prop="logo">
                                    <div class="text-left"
                                         style="font-size: medium; color: #606266;border-radius: 10px;"><strong>Logo
                                        *</strong></div>
                                    <el-row>
                                        <el-alert
                                                v-if="erreurFormat"
                                                type="error"
                                                show-icon
                                        >
                                            <div style="font-size: 17px;">Le logo doit être au format .jpg</div>
                                        </el-alert>
                                        <el-alert
                                                v-if="erreurTaille"
                                                type="error"
                                                show-icon
                                        >
                                            <div style="font-size: 17px;">Le logo ne peut pas excéder 2Mb</div>
                                        </el-alert>
                                    </el-row>
                                    <br/>
                                    <div v-if="logoDiffuseur != ''|| this.logoOk"><br/></div>

                                    <el-row v-if="nouveauDiffuseur.logo != ''"
                                            style="border: dashed #4ABAC7 2px;border-radius: 10px; margin-top: -70px;">
                                        <el-col :span="24">
                                            <img v-if="logoDiffuseur != ''" :src="nouveauDiffuseur.logo"
                                                 width="200px" class="avatar">
                                            <img v-if="nouveauDiffuseur.logo!='' && logoDiffuseur == ''"
                                                 :src="src()" width="200px"
                                                 class="avatar">
                                        </el-col>
                                        <el-col :span="24">
                            <span v-if="logoDiffuseur != ''|| this.logoOk">
                                <el-button type="danger"
                                           icon="el-icon-delete"
                                           @click="supprimerLogo"
                                           class="buttonLogo"></el-button></span>
                                        </el-col>
                                    </el-row>
                                    <el-row v-if="nouveauDiffuseur.logo == '' && !this.logoOk"
                                            style="border: dashed #4ABAC7 2px;border-radius: 10px;margin-top: -30px;">
                                        <el-upload
                                                class="avatar-uploader"
                                                :action="action"
                                                :on-success="handleAvatarSuccess"
                                                :before-upload="beforeAvatarUpload"
                                                :show-file-list="false"
                                                :headers="headers"
                                                v-model="nouveauDiffuseur.logo"
                                                v-loading="chargementLogo"
                                        >
                                            <el-button slot="trigger" type="text" class="buttonDownload"><br/><i
                                                    class="el-icon-upload"></i><br/>
                                                <div class="txtButtonDownload">Cliquez ici</div>
                                            </el-button>
                                        </el-upload>
                                    </el-row>
                                    <div class="text-left messageCategories"
                                         v-if="nouveauDiffuseur.logo == '' && !this.logoOk">Fichier
                                        jpg avec une taille inférieure à 2 Mo
                                    </div>
                                </el-form-item>
                            </el-row>
                            <!--FIN LOGO-->
                            <el-row>
                                <el-col :sm="24" :xs="24" class="text-left">
                                    <el-form-item label="Descriptif de votre diffuseur  *" prop="description"><small
                                            class="messageCategories">Visible sur votre fiche diffuseur</small>
                                        <el-input
                                                type="textarea"
                                                :rows="3"
                                                v-model="nouveauDiffuseur.description">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :sm="24" :xs="24" class="text-left">
                                    <el-form-item label="Tarifs publics *" prop="tarifsPublics">
                                        <el-input
                                                type="textarea"
                                                :rows="3"
                                                v-model="nouveauDiffuseur.tarifsPublics">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :sm="24" :xs="24" class="text-left">
                                    <el-form-item label="Offre tarifaire spéciale pour les clients Ubiflow">
                                        <el-input
                                                type="textarea"
                                                :rows="3"
                                                v-model="nouveauDiffuseur.offresSpecialesUbiflow">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :sm="24" :xs="24" class="text-left">
                                    <el-form-item label="Règles de diffusion">
                                        <el-input
                                                type="textarea"
                                                :rows="3"
                                                v-model="nouveauDiffuseur.reglesDiffusion">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-button class="buttonFonceOnglet2" v-if="nouveauDiffuseur.validationCodeClient"
                                           v-on:click="submitForm">
                                    Envoyer
                                </el-button>
                                <el-button class="buttonSuppOnglet" type="danger"
                                           v-on:click="supprimerDemandeModeCreation = true"
                                           v-if="nouveauDiffuseur.id != ''">
                                    Supprimer
                                </el-button>
                                <el-button class="buttonClaireOnglet"
                                           v-on:click="sortirModeCreation">
                                    Annuler
                                </el-button>
                            </el-row>
                            <el-row style="margin-top: 1%;">
                                <el-button class="buttonJauneOnglet" v-on:click="submitFormEnCours" type="warning">
                                    Sauvegarder et revenir ultérieurement
                                </el-button>
                            </el-row>
                            <br/><br/>
                            <!--        Dialog de confirmation suppression de la demande-->
                            <el-dialog
                                    :visible.sync="supprimerDemandeModeCreation"
                                    width="700px"
                                    center
                                    :close-on-press-escape='true'
                                    :close-on-click-modal='true'
                                    :show-close='true'>
                                <el-header class="text-left blockHeaderDialogHeader">
                                    Supression d'une demande en cours de création
                                    <div class="text-center hr2Header"></div>
                                </el-header>
                                <el-main>
                                    <p class="text-justify" style="word-break: break-word; font-size: large">
                                        Vous êtes sur le point de supprimer cette demande.<br/>
                                        Souhaitez-vous continuer ?
                                    </p>
                                    <p>
                                        <el-button class="buttonFonceOnglet2"
                                                   v-on:click="supprimerQualification"
                                                   v-if="nouveauDiffuseur.id != ''">
                                            Oui
                                        </el-button>
                                        <el-button class="buttonClaireOnglet" style="margin-right: 1%;"
                                                   v-on:click="supprimerDemandeModeCreation = false">
                                            Non
                                        </el-button>
                                    </p>
                                </el-main>
                            </el-dialog>
                        </div>
                    </el-form>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import axios from "axios";

    let authHeader = require('../../_helpers/auth-header');
    export default {
        name: "creation_flux",
        props: ['modeCreationNouveauFlux'],
        data: () => ({
            nouveauDiffuseur: {
                id: '',
                univers: '',
                metierImmo: '',
                metierVo: '',
                modeleEconomique: '',
                nbAnnoncesGratuites: 0,
                bouquetVisibilite: '',
                categoriesImmo: [],
                categoriesVo: [],
                description: '',
                tarifsPublics: '',
                offresSpecialesUbiflow: '',
                reglesDiffusion: '',
                validationCodeClient: false,
                clientCommun: '',
                nomDuClientCommun: '',
                prive: 'Non',
                etat: '',
                web: '',
                nom: '',
                logo: null,
                nomDiffuseur: '',
                url: '',
            },
            action: '',
            headers: {},
            chargementLogo: false,
            loading: false,
            logoDiffuseur: '',
            logoOk: false,
            erreurFormat: false,
            erreurTaille: false,
            afficherChoixVisibilite: false,
            desactiverCategorieSiteClient: false,
            desactiverCategoriesVo: false,
            desactiverCategoriesImmo: false,
            supprimerDemandeModeCreation: false,
            erreurClientCommun: false,
            clientCommunValide: false,
            texteLoading: "",
            rules: {
                univers: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                metierImmo: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                metierVo: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                modeleEconomique: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                nbAnnoncesGratuites: [{
                    required: true,
                    message: 'Ce champ est obligatoire',
                    trigger: ['blur', 'change']
                }],
                bouquetVisibilite: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                categoriesImmo: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                categoriesVo: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                description: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                tarifsPublics: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                validationCodeClient: [{
                    required: true,
                    message: 'Ce champ est obligatoire',
                    trigger: ['blur', 'change']
                }],
                clientCommun: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                nomDuClientCommun: [{
                    required: true,
                    message: 'Ce champ est obligatoire',
                    trigger: ['blur', 'change']
                }],
                etat: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
            }
        }),
        methods: {
            /**
             * gère la partie site client privé
             */
            gestionCategories() {
                let voEstSitePrive = false;
                let immoEstSitePrive = false;
                if (this.nouveauDiffuseur.univers == 'Immobilier') {
                    if (this.nouveauDiffuseur.categoriesImmo.length == 1 && this.nouveauDiffuseur.categoriesImmo[0] == "site client privé") {
                        immoEstSitePrive = true;
                    } else if (this.nouveauDiffuseur.categoriesVo.length == 1 && this.nouveauDiffuseur.categoriesVo[0] == "site client privé") {
                        this.nouveauDiffuseur.categoriesVo = [];
                    }
                } else if (this.nouveauDiffuseur.univers == 'automobile') {
                    if (this.nouveauDiffuseur.categoriesVo.length == 1 && this.nouveauDiffuseur.categoriesVo[0] == "site client privé") {
                        immoEstSitePrive = true;
                    } else if (this.nouveauDiffuseur.categoriesImmo.length == 1 && this.nouveauDiffuseur.categoriesImmo[0] == "site client privé") {
                        this.nouveauDiffuseur.categoriesImmo = [];
                    }
                }
                if (this.nouveauDiffuseur.categoriesImmo.length == 0 && this.nouveauDiffuseur.categoriesVo.length == 0) {
                    this.desactiverCategoriesImmo = false;
                    this.desactiverCategoriesVo = false;
                    this.desactiverCategorieSiteClient = false;
                    this.afficherChoixVisibilite = false;
                } else {
                    if (immoEstSitePrive || voEstSitePrive) {
                        this.desactiverCategoriesImmo = true;
                        this.desactiverCategoriesVo = true;
                        this.desactiverCategorieSiteClient = false;
                        this.nouveauDiffuseur.categoriesImmo = ["site client privé"];
                        this.nouveauDiffuseur.categoriesVo = ["site client privé"];
                        this.nouveauDiffuseur.prive = "Oui";
                        this.afficherChoixVisibilite = false;
                    } else {
                        this.desactiverCategoriesImmo = false;
                        this.desactiverCategoriesVo = false;
                        this.desactiverCategorieSiteClient = true;
                        this.afficherChoixVisibilite = true;
                    }
                }
            },
            gestionAffichageCodeClient() {
                this.nouveauDiffuseur.clientCommun = '';
                this.erreurClientCommun = false;
            },
            /**
             * permet de retourner à la liste des diffuseurs
             */
            sortirModeCreation() {
                this.$router.push(
                    {
                        path: "/diffuseurs"
                    }
                ).catch(err => {
                });
            },
            /**
             * Vérifie que le questionnaire est remplit entièrement
             * @return int
             **/
            async submitForm() {
                this.$ga.event('page_ajouter_flux', 'clic', 'enregistrer_nouveau_flux');
                await this.$refs['nouveauDiffuseur'].validate((valid) => {
                    if (valid) {
                        this.scrollWin();
                        this.loading = true;
                        this.texteLoading = "Transmission de votre demande à notre équipe";
                        if (this.nouveauDiffuseur.etat == "") {
                            this.sendForm(true);
                        } else if (this.nouveauDiffuseur.etat == "En cours") {
                            this.sendModifications(true);
                        }
                    }
                });
            },
            async submitFormEnCours() {
                this.loading = true;
                this.texteLoading = "Sauvegarde en cours... ";
                this.$ga.event('page_ajouter_flux', 'clic', 'sauvegarder_et_revenir_ulterieurement');
                if (this.nouveauDiffuseur.etat == "") {
                    this.sendForm(false);
                } else if (this.nouveauDiffuseur.etat == "En cours") {
                    this.sendModifications(false);
                }
            },
            /**
             * Creation d'un ticket dans redmine
             */
            async sendRedmine(idQualif) {
                let token = await authHeader.getToken();
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token.token,
                        'Content-Type': 'application/json'
                    }
                };
                let data = {};
                return axios
                    .post(
                        processEnvConfig.VUE_APP_PORTAILS_API_URL + '/creationNouveauFlux/' + this.$store.getters.getUserSugar().nom +
                        '/' + this.$store.getters.getUser().username + '/' + idQualif,
                        data,
                        config
                    )
                    .then(response => {
                        this.confirmationCreationDeFlux();
                        this.$router.push({
                            path: '/demandes'
                        })
                        return response.data
                    })
                    .catch(error => {
                        this.errored = true
                        return error
                    })
                this.loading = true;
            },
            confirmationCreationDeFlux() {
                this.$message({
                    showClose: true,
                    message: 'Votre demande a été enregistrée.',
                    type: 'success'
                });
            },
            confirmationEnregistrement() {
                this.$message({
                    showClose: true,
                    message: 'La sauvegarde a été effectuée',
                    type: 'success'
                });
            },
            confirmationSuppression() {
                this.$message({
                    showClose: true,
                    message: 'La demande a été supprimée',
                    type: 'success'
                });
            },

            /**
             * Mettre a jour la BDD après modification
             */
            async sendModifications(envoyerARedmine) {
                let token = await authHeader.getToken();
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token.token,
                        'Content-Type': 'application/json'
                    }
                };
                let urlLogo;
                if(this.nouveauDiffuseur.logo) {
                    if (this.nouveauDiffuseur.logo.includes(processEnvConfig.VUE_APP_PORTAILS_API_URL)) {
                        urlLogo = this.nouveauDiffuseur.logo;
                    } else {
                        urlLogo = processEnvConfig.VUE_APP_PORTAILS_API_URL + '/fichiers' + this.nouveauDiffuseur.logo;
                    }
                }else{
                    urlLogo = null;
                }
                let user = processEnvConfig.VUE_APP_PORTAILS_API_URL + '/users/' + this.$store.getters.getUser().id;
                let params = {
                    logo: urlLogo,
                    nomDiffuseur: this.nouveauDiffuseur.nomDiffuseur,
                    url: this.nouveauDiffuseur.url,
                    user: user,
                    univers: this.nouveauDiffuseur.univers,
                    metierImmo: this.nouveauDiffuseur.metierImmo,
                    metierVo: this.nouveauDiffuseur.metierVo,
                    modeleEconomique: this.nouveauDiffuseur.modeleEconomique,
                    nbAnnoncesGratuites: this.nouveauDiffuseur.nbAnnoncesGratuites,
                    informationsFreemium: '',
                    bouquetVisibilite: this.nouveauDiffuseur.bouquetVisibilite,
                    categoriesImmo: this.nouveauDiffuseur.categoriesImmo,
                    categoriesVo: this.nouveauDiffuseur.categoriesVo,
                    description: this.nouveauDiffuseur.description,
                    tarifsPublics: this.nouveauDiffuseur.tarifsPublics,
                    offresSpecialesUbiflow: this.nouveauDiffuseur.offresSpecialesUbiflow,
                    reglesDiffusion: this.nouveauDiffuseur.reglesDiffusion,
                    validationCodeClient: this.nouveauDiffuseur.validationCodeClient,
                    clientCommun: this.nouveauDiffuseur.clientCommun,
                    nomDuClientCommun: this.nouveauDiffuseur.nomDuClientCommun,
                    estPrive: this.nouveauDiffuseur.prive,
                    etat: 'En cours'
                }
                return axios
                    .put(
                        processEnvConfig.VUE_APP_PORTAILS_API_URL + '/qualifications/' + this.nouveauDiffuseur.id,
                        params,
                        config
                    )
                    .then(response => {
                        this.nouveauDiffuseur.id = response.data.id;
                        this.nouveauDiffuseur.etat = response.data.etat;
                        this.scrollWin();
                        if (envoyerARedmine) {
                            this.sendRedmine(response.data.id)
                        } else {
                            this.confirmationEnregistrement();
                        }
                        this.loading = false;
                        return response.data
                    })
                    .catch(error => {
                      this.errored = true
                      return error
                    })
            },
            /**
             * Mettre a jour la BDD après modification
             */
            async sendForm(envoyerARedmine) {
                let token = await authHeader.getToken();
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token.token,
                        'Content-Type': 'application/json'
                    }
                };
                let urlLogo;
                if(this.nouveauDiffuseur.logo) {
                    if (this.nouveauDiffuseur.logo.includes(processEnvConfig.VUE_APP_PORTAILS_API_URL)) {
                        urlLogo = this.nouveauDiffuseur.logo;
                    } else {
                        urlLogo = processEnvConfig.VUE_APP_PORTAILS_API_URL + '/fichiers' + this.nouveauDiffuseur.logo;
                    }
                }else{
                    urlLogo = null;
                }
                let user = processEnvConfig.VUE_APP_PORTAILS_API_URL + '/users/' + this.$store.getters.getUser().id;
                let params = {
                    logo: urlLogo,
                    nomDiffuseur: this.nouveauDiffuseur.nomDiffuseur,
                    url: this.nouveauDiffuseur.url,
                    user: user,
                    univers: this.nouveauDiffuseur.univers,
                    metierImmo: this.nouveauDiffuseur.metierImmo,
                    metierVo: this.nouveauDiffuseur.metierVo,
                    modeleEconomique: this.nouveauDiffuseur.modeleEconomique,
                    nbAnnoncesGratuites: this.nouveauDiffuseur.nbAnnoncesGratuites,
                    informationsFreemium: '',
                    bouquetVisibilite: this.nouveauDiffuseur.bouquetVisibilite,
                    categoriesImmo: this.nouveauDiffuseur.categoriesImmo,
                    categoriesVo: this.nouveauDiffuseur.categoriesVo,
                    description: this.nouveauDiffuseur.description,
                    tarifsPublics: this.nouveauDiffuseur.tarifsPublics,
                    offresSpecialesUbiflow: this.nouveauDiffuseur.offresSpecialesUbiflow,
                    reglesDiffusion: this.nouveauDiffuseur.reglesDiffusion,
                    validationCodeClient: this.nouveauDiffuseur.validationCodeClient,
                    clientCommun: this.nouveauDiffuseur.clientCommun,
                    nomDuClientCommun: this.nouveauDiffuseur.nomDuClientCommun,
                    estPrive: this.nouveauDiffuseur.prive,
                    dateCreationDemande: new Date().getDate() + '-' + ((new Date().getMonth()) + 1) + '-' + new Date().getFullYear(),
                    etat: 'En cours'
                };
                return axios
                    .post(
                        processEnvConfig.VUE_APP_PORTAILS_API_URL + '/qualifications',
                        params,
                        config
                    )
                    .then(response => {
                        this.nouveauDiffuseur.id = response.data.id;
                        this.nouveauDiffuseur.etat = response.data.etat;
                        this.scrollWin();
                        if (envoyerARedmine) {
                            this.sendRedmine(response.data.id)
                        } else {
                            this.confirmationEnregistrement();
                        }
                        this.loading = false;
                        return response.data
                    })
                    .catch(error => {
                        this.errored = true
                        return error
                    })
            },
            /**
             * permet de chager le formulaire à éditer
             */
            async chargerQualification(id) {
                let token = await authHeader.getToken();
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token.token,
                        'Content-Type': 'application/json'
                    }
                };
                return axios
                    .get(
                        processEnvConfig.VUE_APP_PORTAILS_API_URL + '/qualifications/' + id,
                        config
                    )
                    .then(response => {
                        this.nouveauDiffuseur.id = id;
                        this.nouveauDiffuseur.univers = response.data.univers;
                        this.nouveauDiffuseur.metierImmo = response.data.metierImmo;
                        this.nouveauDiffuseur.metierVo = response.data.metierVo;
                        this.nouveauDiffuseur.modeleEconomique = response.data.modeleEconomique;
                        this.nouveauDiffuseur.nbAnnoncesGratuites = response.data.nbAnnoncesGratuites;
                        this.nouveauDiffuseur.bouquetVisibilite = response.data.bouquetVisibilite;
                        this.nouveauDiffuseur.categoriesImmo = response.data.categoriesImmo;
                        this.nouveauDiffuseur.categoriesVo = response.data.categoriesVo;
                        this.nouveauDiffuseur.description = response.data.description;
                        this.nouveauDiffuseur.tarifsPublics = response.data.tarifsPublics;
                        this.nouveauDiffuseur.offresSpecialesUbiflow = response.data.offresSpecialesUbiflow;
                        this.nouveauDiffuseur.reglesDiffusion = response.data.reglesDiffusion;
                        this.nouveauDiffuseur.validationCodeClient = response.data.validationCodeClient;
                        this.nouveauDiffuseur.nomDiffuseur = response.data.nomDiffuseur;
                        this.nouveauDiffuseur.url = response.data.url;
                        this.clientCommunValide = response.data.validationCodeClient;
                        this.nouveauDiffuseur.clientCommun = response.data.clientCommun;
                        this.nouveauDiffuseur.nomDuClientCommun = response.data.nomDuClientCommun;
                        if (response.data.estPrive == null) {
                            this.nouveauDiffuseur.prive = 'Non';
                        } else {
                            this.nouveauDiffuseur.prive = response.data.estPrive;
                        }
                        this.nouveauDiffuseur.etat = 'En cours';
                        this.chargerLogo(response.data.logo);
                        this.gestionCategories();
                        this.loading = false;
                        return response.data
                    })
                    .catch(error => {
                        this.errored = true
                        return error
                    })
            },
            /**
             * On charge le logo.
             * @returns {Promise<void>}
             */
            async chargerLogo(logo) {
                this.chargementLogo = true;
                if (logo != null && logo != "") {
                    this.nouveauDiffuseur.logo = logo;
                    this.logoDiffuseur = logo;
                    this.logoOk = true;
                } else {
                    this.nouveauDiffuseur.logo = "";
                    this.logoDiffuseur = "";
                    this.logoOk = false;
                }
                this.erreurFormat = false;
                this.erreurTaille = false;
                this.chargementLogo = false;
            },
            /**
             * Supprime la qualification
             */
            async supprimerQualification() {
                let token = await authHeader.getToken();
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token.token,
                        'Content-Type': 'application/json'
                    }
                };
                let params = {};
                return axios
                    .post(
                        processEnvConfig.VUE_APP_PORTAILS_API_URL + '/deleteQualification/' + this.nouveauDiffuseur.id,
                        params,
                        config
                    )
                    .then(response => {
                        this.confirmationSuppression();
                        this.supprimerDemandeModeCreation = false;
                        this.$router.push(
                            {
                                name: "demandes"
                            }
                        );
                        return response.data
                    })
                    .catch(error => {
                        this.errored = true
                        return error
                    })
            },
            /**
             * Permet de contrôler le client commun
             * @returns {Promise<number | {login: *} | {login: *} | {login: *} | {login: *} | string>}
             */
            async validationCodeClient() {
                this.$ga.event('page_ajouter_flux', 'clic', 'valide_code_ag');
                let token = await authHeader.getToken();
                let config = {
                    headers: {'Authorization': "Bearer " + token.token}
                };
                let univers;
                let metier;
                if (this.nouveauDiffuseur.metierImmo == 'Offre (vente/location)' || this.nouveauDiffuseur.metierImmo == 'Bien particulier/professionnels') {
                    metier = 'AGENCE';
                } else if (this.nouveauDiffuseur.metierImmo == 'Maison individuelles (Constructeurs)') {
                    metier = 'CMI';
                } else if (this.nouveauDiffuseur.metierImmo == 'Programmes (totalité programme neuf)' || this.nouveauDiffuseur.metierImmo == 'Programmes (annonce par bien)') {
                    metier = 'PROMOTEUR';
                } else if (this.nouveauDiffuseur.metierVo == 'Voitures et utilitaires') {
                    metier = 'CONCESSIONNAIRE';
                } else if (this.nouveauDiffuseur.metierVo == 'Motos') {
                    metier = 'CONCESSIONNAIRE_MOTO';
                }
                if (this.nouveauDiffuseur.univers == "Immobilier") {
                    univers = 'IMMO';
                } else {
                    univers = 'VO';
                }
                return axios
                    .get(
                        processEnvConfig.VUE_APP_UBIFLOW_API_URL + '/annonceur?univers=' + univers + '&affiliation_modele_economique='
                        + this.nouveauDiffuseur.modeleEconomique.toLowerCase() + '&login=ag' + this.nouveauDiffuseur.clientCommun + '&type_objet=' + metier,
                        config
                    )
                    .then(response => {
                        if (response.data._embedded.annonceur.length == 0) {
                            this.$ga.event('page_ajouter_flux', 'clic', 'code_ag_invalide');
                            this.erreurClientCommun = true;
                            this.nouveauDiffuseur.nomDuClientCommun = '';
                            this.nouveauDiffuseur.validationCodeClient = false;
                        } else if (response.data._embedded.annonceur.length == 1) {
                            this.$ga.event('page_ajouter_flux', 'succes', 'code_ag_valide');
                            this.erreurClientCommun = false;
                            this.clientCommunValide = true;
                            this.nouveauDiffuseur.nomDuClientCommun = response.data._embedded.annonceur[0].nom + ' à ' + response.data._embedded.annonceur[0].ville;
                            this.nouveauDiffuseur.validationCodeClient = true;
                            this.chargerLogo(null);
                        }
                        return response.data._embedded.annonceur;
                    })
                    .catch(error => {
                        this.errored = true
                        return error
                    })
            },
            /**
             * Permet de modifier le code client commun
             */
            effacerCodeClientCommun() {
                this.erreurClientCommun = true;
                this.clientCommunValide = false;
                this.nouveauDiffuseur.validationCodeClient = false;
            },
            verificationPage() {
                let idSelectionne = this.$route.params.id;
                if (idSelectionne != null) {
                    this.texteLoading = "Chargement en cours...";
                    this.loading = true;
                    this.chargerQualification(idSelectionne);
                }
            },
            scrollWin() {
                window.scrollTo(500, 0);
            },
            // DEBUT METHODE LOGO
            handleAvatarSuccess(res, file) {
                this.$ga.event('page_mes_informations', 'clic', 'ajout_logo');
                this.nouveauDiffuseur.logo = res.contentUrl;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    // this.$message.error('L\'avatar doit être en JPG !');
                    this.erreurFormat = true;
                    this.logoOk = false;
                } else {
                    this.erreurFormat = false;
                }
                if (!isLt2M) {
                    // this.$message.error('L\'avatar ne peut pas excéder 2Mb !');
                    this.erreurTaille = true;
                    this.logoOk = false;
                } else {
                    this.erreurTaille = false;
                }
                if (isJPG && isLt2M) {
                    this.erreurTaille = false;
                    this.erreurFormat = false;
                    this.logoOk = true;
                }
                return isJPG && isLt2M;
            },
            src(lien = null) {
                return processEnvConfig.VUE_APP_PORTAILS_API_URL + '/fichiers' + this.nouveauDiffuseur.logo;
            },
            /**
             * Méthode qui sert à supprimer le logo
             */
            async supprimerLogo() {
                this.$ga.event('page_mes_informations', 'clic', 'supprimer_logo');
                if (this.logoDiffuseur) {
                    this.logoDiffuseur = '';
                    this.nouveauDiffuseur.logo = '';
                    this.logoOk = false;
                } else {
                    let token = await authHeader.getToken();
                    let config = {
                        headers: {
                            'Authorization': "Bearer " + token.token
                        }
                    };
                    let params = {};
                    let imagePath = this.nouveauDiffuseur.logo.replace('/media/', '');
                    return axios
                        .post(
                            processEnvConfig.VUE_APP_PORTAILS_API_URL + '/media_objects/delete/' + imagePath,
                            params,
                            config
                        )
                        .then(response => {
                            this.nouveauDiffuseur.logo = '';
                            this.erreurFormat = false;
                            this.erreurTaille = false;
                            this.logoOk = false;
                            return response.data
                        })
                        .catch(error => {
                            this.errored = true
                            return error
                        })
                }
            },
        },
        async mounted() {
            let token = await authHeader.getToken();
            this.headers = {
                Authorization: 'Bearer ' + token.token,
            };
            this.action = processEnvConfig.VUE_APP_PORTAILS_API_URL + '/media_objects';
            this.verificationPage();

        }
    }
</script>

<style scoped>
    @import "../../../public/css/stylesPageOnglet.css";
    @import "../../../public/css/stylePages.css";
</style>